//import React from 'react'

import clean from 'vegas-js-core/src/objects/clean'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import blueGrey from '@material-ui/core/colors/blueGrey'

//import { FaBriefcaseMedical } from 'react-icons/fa'

import withDialogs from '../../../../../../contexts/dialogs/withDialogs'
import withi18n    from '../../../../../../contexts/i18n/withi18n'

import ChipsContainer, { styles } from '../../../../../containers/ChipsContainer'

import api from '../../../../../../configs/api'

import AbortionEvent   from '../../../../../../things/livestock/events/AbortionEvent'
import MedicalAnalysis from '../../../../../../things/medical/MedicalAnalysis'
import Thing           from '../../../../../../things/Thing'
import Word            from '../../../../../../things/Word'

const css = () => (
{
    ...styles,
    chip :
    {
        backgroundColor : blueGrey[100],
        margin          : 8
    }
});

class Sampling extends ChipsContainer
{
    getEntry = init =>
    {
        const { subjectOf } = this.props ;

        let empty = {} ;

        if( init instanceof Thing )
        {
            empty = init.toObject() ;
        }
        else if( init )
        {
            empty = { ...init } ;
        }

        return new MedicalAnalysis( { ...empty , subjectOf } ) ;
    };

    getLocale = () => this.props.locale.things.livestock.reviews.abortion.medical.sampling ;

    editInit = ( item ) =>
    {
        if( item )
        {
            const { sampling } = item ;
            if( sampling instanceof Array )
            {
                return sampling.map( element =>
                {
                    if( element instanceof Word )
                    {
                        return element.clone() ;
                    }
                    return null ;
                })
            }
        }
        return null ;
    };

    onEdit = ( item ) =>
    {
        const { onChange } = this.props ;
        if( onChange )
        {
            onChange( item ) ;
        }
    };

    editPrepare = ( datas , props ) =>
    {
        let { item:analysis } = props ;
        if( analysis instanceof MedicalAnalysis )
        {
            const { id } = analysis ;
            const { subjectOf:event } = analysis ;
            if( event instanceof AbortionEvent )
            {
                let { subjectOf:review } = event ;
                if( review )
                {
                    const { analysis:analyses } = event ;

                    if( analyses instanceof Array )
                    {
                        let position = analyses.findIndex( item => item.id === id ) ;
                        if( position > -1 )
                        {
                            analyses[position].sampling = datas ;
                        }
                    }

                    review = clean(review.toObject()) ;

                    //console.log( this + ' editPrepare review ::::' , review ) ;

                    return { review:JSON.stringify(review) } ;
                }
            }

        }
        return null ;
    };
}

Sampling.defaultProps =
{
    ...ChipsContainer.defaultProps ,
    chipVariant : 'default' ,
    editUri     : ( path, props ) =>
    {
        const { subjectOf } = props ;
        if( subjectOf )
        {
            const { subjectOf:review } = subjectOf ;
            if( review )
            {
                const { subjectOf:observation } = review ;
                if( observation )
                {
                    const { id } = observation ;
                    if( id )
                    {
                        return api.observations.url + '/' + id ;
                    }
                }
            }
        }
        return null ;
    },
    icon       : null, //<FaBriefcaseMedical size={18}/>,
    member     : 'sampling',
    optionMode : 'none' ,
    titleMode  : 'edit'
};

Sampling.propTypes =
{
    ...ChipsContainer.propTypes
};

export default withStyles( css ) ( withRouter( withi18n( withDialogs( Sampling ) ) ) ) ;
